import React, { useState } from 'react';
import Card from '../components/Cards/Card';
import mod from './ChatApp.module.css';
import SelectUser from '../components/Forms/SelectUserForm';
import ChatWithUser from '../components/Forms/ChatWithUserForm';

function ChatAppPage() {
	const [username, setUsername] = useState('');
	const [messageData, setMessageData] = useState([]);
	const [lastUser, setLastUser] = useState('');
	const [isUserSelected, setIsUserSelected] = useState(false);

	const HandlerSearchUser = (username, message, lastUser) => {
		setUsername(username);
		setMessageData(message);
		setLastUser(lastUser);
		setIsUserSelected(true);
		// Aici poți adăuga logica pentru a trimite mesajul către server sau a-l afișa în chat
	};

	const HandlerChatWithUser = (messageSent, fromUser) => {
		console.log('Mesaj trimis:', messageSent);
		setLastUser(fromUser);
		// Aici poátii adăuga logica pentru a trimite mesajul către server sau a-l afiša în chat
	};

	const HandlerGoBackToSelectUser = () => {
		setIsUserSelected(false);
		console.log('Inapoi la selectarea utilizatorului');
	};
	return (
		<Card className={mod.ChatAppCard}>
			<div className={mod.ChatApp}>
				<h1>ChatApp</h1>
				{!isUserSelected && (
					<SelectUser
						className={mod.ChatFormCard}
						SearchUser={HandlerSearchUser}
					/>
				)}
				{isUserSelected && (
					<ChatWithUser
						className={mod.ChatFormCard}
						username={username}
						lastUser={lastUser}
						messageData={messageData}
						chatWithUser={HandlerChatWithUser}
						goBackToSelectUser={HandlerGoBackToSelectUser}
					/>
				)}
			</div>
		</Card>
	);
}

export default ChatAppPage;
